<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="content"><a id="page_vi"></a><a id="page_vii"></a>Contents</h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr><td valign="top"><p class="tocfront"><a class="nounder" href="#/xhtml/acknowledgment#acknowledgment"><em>Acknowledgments</em></a></p></td></tr>
<tr><td valign="top"><p class="tocfront1"><a class="nounder" href="#/xhtml/introduction#introduction"><em>Introduction</em></a></p></td></tr>
<tr><td valign="top"><p class="tocchap"><a class="nounder" href="#/xhtml/prologue#prologue">Prologue</a></p></td></tr>
<tr><td valign="top"><p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">1 The Baby Boom: <em>The Self-Involved Glacier</em></a></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 The Social Safety Net for Older Americans: <em>The Expensive Legacy of the New Deal</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 Living to Work: <em>Boomers, Retirement, and the Knowledge Economy</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Healthy Aging: <em>Enabling a Longer, More Active Life</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Encouraging Work in Later Life: <em>What Can Be Done?</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Medicare: <em>The Mount Everest of Entitlements</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Social Security Reform: <em>Grasping the Third Rail</em></span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 What We Need to Do</span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 What Baby Boomers Should Do for Themselves</span></p></td></tr>
<tr><td valign="top"><p class="tocchap"><span class="nounder" href="#/xhtml/conclusion#conclusion" title="Link target outside of Sample">Conclusion</span></p></td></tr>
<tr><td valign="top"><p class="tocback1"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p></td></tr>
<tr><td valign="top"><p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p></td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?51387a62